import { QuestionContent, QuestionIcon, QuestionItem, QuestionsContainer, QuestionsTitle, QuestionTitle } from "./style";

const Intro = (props) => {
  const { t } = props

  const schemas = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [{
            "@type": "Question",
            "name": t('questions:question-1'),
            "acceptedAnswer": {
            "@type": "Answer",
            "text": t('questions:question-1-a')
            }
        },{
            "@type": "Question",
            "name": t('questions:question-2'),
            "acceptedAnswer": {
            "@type": "Answer",
            "text": t('questions:question-2-a')
            }
        },{
            "@type": "Question",
            "name": t('questions:question-3'),
            "acceptedAnswer": {
            "@type": "Answer",
            "text": t('questions:question-3-a1') + ' ' + t('questions:question-3-a2')
            }
        },{
            "@type": "Question",
            "name": t('questions:question-4'),
            "acceptedAnswer": {
            "@type": "Answer",
            "text": t('questions:question-4-a1') + ' ' + t('questions:question-4-a2') + ' ' + t('questions:question-4-a3')
            }
        },{
            "@type": "Question",
            "name": t('questions:question-5'),
            "acceptedAnswer": {
            "@type": "Answer",
            "text": t('questions:question-5-a1') + ' ' + t('questions:question-5-a2') + ' ' + t('questions:question-5-a3')
            }
        }]
    }

  return (
    <>
        <QuestionsContainer>
            <QuestionsTitle>{t('Frequently Asked Questions')}</QuestionsTitle>
            <div style={{ background: '#f84f7f', width: '150px', height: '2px', margin: '30px auto' }}></div>
            <QuestionItem>
                <QuestionTitle >
                    <QuestionIcon></QuestionIcon>{t('questions:question-1')}
                </QuestionTitle>
                <QuestionContent>{t('questions:question-1-a')}</QuestionContent>
            </QuestionItem>
            <QuestionItem>
                <QuestionTitle ><QuestionIcon></QuestionIcon>{t('questions:question-2')}</QuestionTitle>
                <QuestionContent>{t('questions:question-2-a')}</QuestionContent>
            </QuestionItem>
            <QuestionItem>
                <QuestionTitle ><QuestionIcon></QuestionIcon>{t('questions:question-3')}</QuestionTitle>
                <QuestionContent>
                    <ul>
                        <li>{t('questions:question-3-a1')}</li>
                        <li>{t('questions:question-3-a2')}</li>
                    </ul>
                </QuestionContent>
            </QuestionItem>
            <QuestionItem>
                <QuestionTitle ><QuestionIcon></QuestionIcon>{t('questions:question-4')}</QuestionTitle>
                <QuestionContent>
                    <ul>
                        <li>{t('questions:question-4-a1')}</li>
                        <li>{t('questions:question-4-a2')}</li>
                        <li>{t('questions:question-4-a3')}</li>
                    </ul>
                </QuestionContent>
            </QuestionItem>
            <QuestionItem>
                <QuestionTitle ><QuestionIcon></QuestionIcon>{t('questions:question-5')}</QuestionTitle>
                <QuestionContent>
                    <ul>
                        <li>{t('questions:question-5-a1')}</li>
                        <li>{t('questions:question-5-a2')}</li>
                        <li>{t('questions:question-5-a3')}</li>
                    </ul>
                </QuestionContent>
            </QuestionItem>
        </QuestionsContainer>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemas) }}></script>
    </>
  );
}
export default Intro
